<app-default-layout
  [title]="existsSessionStorageTextbausteine?
    textbausteinService.printTextbausteinByKey( KeyString.TITLE_HOME, ('HOME.TITLE'|translate) ):('HOME.TITLE'|translate)"
  [subtitle]="existsSessionStorageTextbausteine?
    textbausteinService.printTextbausteinByKey( KeyString.SUBTITLE_HOME, ('HOME.SUBTITLE'|translate) ):('HOME.SUBTITLE'|translate)"
  >

  <main role="main" class="container-fluid" aria-label="Willkommensseite">
    <div class="row justify-content-center">
      <div class="col-7">
        <div class="frame frame-full">
          <div id="welcome-page" class="content scaffold-edit justify-content-center">
            <div class="texthome mb-2">
              {{existsSessionStorageTextbausteine?
              textbausteinService.printTextbausteinByKey( KeyString.WELCOME_TEXT_HOME, ('HOME.WELCOME_TEXT'|translate) ):('HOME.WELCOME_TEXT'|translate)}}
            </div>

            @if (existsSessionUser && roleEnabled['Antragsteller']) {
              <div>
                <h3 class="h6 mb-2 mt-3" data-cy="guide-start-heading">So starten Sie:</h3>
                <div class="row g-2 mb-2">
                  <div class="col-md-4">
                    <div class="card h-100 border-0 bg-light" data-cy="guide-card-step1">
                      <div class="card-body p-3 d-flex flex-column">
                        <h4 class="h6 card-title mb-2" data-cy="guide-step1-title">1. Schüler:innen anlegen</h4>
                        <p class="card-text small mb-2">Erfassen Sie alle Schüler:innen und deren schulbesuchende Geschwister.</p>
                        <a [routerLink]="['/pages/schueler-table']" class="btn btn-sm btn-outline-primary w-100 mt-auto" data-cy="guide-step1-button">
                          {{existsSessionStorageTextbausteine?
                          textbausteinService.printTextbausteinByKey( KeyString.SCHUELER_VERWALTEN_MENUE, ('HOME.LINK_SCHUELER_TABLE'|translate) ):('HOME.LINK_SCHUELER_TABLE'|translate)}}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="card h-100 border-0 bg-light" data-cy="guide-card-step2">
                      <div class="card-body p-3 d-flex flex-column">
                        <h4 class="h6 card-title mb-2" data-cy="guide-step2-title">2. Anträge erstellen</h4>
                        <p class="card-text small mb-2">Erstellen Sie die gewünschten Fahrkartenanträge für die Schüler:innen.</p>
                        <a [routerLink]="['/pages/ticket-table']" class="btn btn-sm btn-outline-primary w-100 mt-auto" data-cy="guide-step2-button">
                          {{existsSessionStorageTextbausteine?
                          textbausteinService.printTextbausteinByKey( KeyString.ANTRAEGE_VERWALTEN_MENUE, ('HOME.LINK_TICKET_TABLE'|translate) ):('HOME.LINK_TICKET_TABLE'|translate)}}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="card h-100 border-0 bg-light" data-cy="guide-card-step3">
                      <div class="card-body p-3 d-flex flex-column">
                        <h4 class="h6 card-title mb-2" data-cy="guide-step3-title">3. Fahrkarten verwalten</h4>
                        <p class="card-text small mb-2">Sehen Sie Fahrkarten ein und nehmen Sie, falls nötig, Änderungen vor.</p>
                        <a [routerLink]="['/pages/tickets']" class="btn btn-sm btn-outline-primary w-100 mt-auto" data-cy="guide-step3-button">
                          {{existsSessionStorageTextbausteine?
                          textbausteinService.printTextbausteinByKey( KeyString.LINK_TICKETS_MENUE, ('HOME.LINK_TICKETS'|translate) ):('HOME.LINK_TICKETS'|translate)}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="alert alert-info py-2 px-3 mb-0">
                  <small>
                    {{existsSessionStorageTextbausteine?
                    textbausteinService.printTextbausteinByKey( KeyString.INFO_TEXT_HOME, ('HOME.INFO_TEXT'|translate) ):('HOME.INFO_TEXT'|translate)}}
                  </small>
                  <small class="d-block text-center">
                    <a target="_blank" rel="noopener noreferrer" href="https://www.schulministerium.nrw/fragen-und-antworten-zu-schuelerfahrkosten-und-schuelerticket" data-cy="info" class="alert-link">
                      {{ "HOME.LINK_GENERAL_INFO" | translate }}
                      <span aria-hidden="true" class="ms-1">↗</span>
                    </a>
                  </small>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </main>

</app-default-layout>
